import script from "./PageIndexSix.vue?vue&type=script&setup=true&lang=js"
export * from "./PageIndexSix.vue?vue&type=script&setup=true&lang=js"

import "./PageIndexSix.vue?vue&type=style&index=0&id=2cb98f1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb98f1e"]])

export default __exports__